import React, { createContext, useContext, useState, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';

const ModalContext = createContext();

export function useModal() {
  return useContext(ModalContext);
}

export function ModalProvider({ children }) {
  const [modalConfig, setModalConfig] = useState({
    show: false,
    title: '',
    body: '',
    buttons: []
  });

  const resolverRef = useRef(null); // Guarda a função que resolve a promise

  const showModal = ({ title, body, buttons }) => {
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setModalConfig({
        show: true,
        title,
        body,
        buttons
      });
    });
  };

  const closeModal = (result) => {
    setModalConfig((prev) => ({ ...prev, show: false }));
    if (resolverRef.current) {
      resolverRef.current(result); // Resolve a promise com o valor do botão
      resolverRef.current = null;
    }
  };

  return (
    <ModalContext.Provider value={{ showModal }}>
      {children}

      <Modal className='my-modal'
        backdropClassName="my-modal-backdrop"
        show={modalConfig.show} onHide={() => closeModal(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalConfig.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalConfig.body}</Modal.Body>
        <Modal.Footer>
          {modalConfig.buttons.map((btn, i) => (
            <Button
              key={i}
              variant={btn.variant || 'secondary'}
              onClick={() => closeModal(btn.value)}
            >
              {btn.label}
            </Button>
          ))}
        </Modal.Footer>
      </Modal>
    </ModalContext.Provider>
  );
}